{
	"backLinkTitle": "Tilbake til Administrer erklæringer",
	"invoicedQuantity": "Fakturert mengde",
	"remainingForDeclarationCreation": "Gjenstående for opprettelse av erklæring",
	"nonTransferableAmount": "Ikke-allokerbart beløp",
	"btnCreateDeclaration": "+ Opprett erklæring",
	"errorMessage": "Kunne ikke laste inn materialdetaljer"
}
